import {
  FDBodyText,
  FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import useMobileLayout from 'Hooks/useMobileLayout';

export const TaxSavingsInRoadmapDisclosureSectionLayout = ({
  resource,
}) => {
  const isMobile = useMobileLayout();

  return (
    <FDStack
      direction={'column'}
      paddingX={(isMobile) ? 1 : 8}
      spacing={3}
      alignItems={'center'}
    >
      <FDBodyText size={'sm'} align={'center'} value={resource.attr('content')} />
    </FDStack>
  );
};

TaxSavingsInRoadmapDisclosureSectionLayout.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
